module.exports = __webpack_public_path__ + "levy_round-46638dd99785df0adb7c61b8d66a2acb.png";


//////////////////
// WEBPACK FOOTER
// ./assets/media-images/dk/levy_round.png
// module id = 1163
// module chunks = 1 2